import dompurify from 'dompurify'

export const sanitizeHTML = (html: string) => {
    const formattedHTML = html.replace(/\n/g, '<br>')

    return dompurify.sanitize(formattedHTML, {
        ALLOWED_TAGS: ['p', 'ul', 'li', 'br', 'b', 'i', 'a'],
        ALLOWED_ATTR: ['href', 'style'],
    })
}
